import { BaseEntity } from "yt-ng-framework";

export class AkciznaRoba extends BaseEntity {

    constructor() {
        super();
    }

    Naziv: string = null;
    IsDefault: boolean = null;

    Deserialize(input: any) {
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.IsDefault = input.IsDefault;
        return this;
    }

    Serialize(input: AkciznaRoba) {
        return input;
    }
}
